import numeral from 'numeral';

const config = {
  builder_id: '5e6fb4e44db0486b6c09d89c',
  auth_domain: 'lagunaisles.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/i-social-facebook.svg',
    instagram: '/images/i-social-instagram.svg',
    youtube: '/images/i-social-youtube.svg',
    pinterest: '/images/i-social-pinterest.svg',
    twitter: '/images/i-social-twitter.svg',
    houzz: '/images/i-social-houzz.svg',
    linkedin: '/images/i-social-linkedin.svg',
    fallback: '/images/i-social-facebook.svg',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2s4a2d2dDZiMDFxbDNnbndhZ3k1MGtsbSJ9.J2GG_OfmQjkM7EBS34LvLA',
    tileUrl: 'https://api.mapbox.com/styles/v1/builderdesigns/ckgtuw0xq376019malv7wvf11/tiles/256/{z}/{x}/{y}',
  },
  filters: {
    all: {
      Area: {
        routeParam: 'communityMarketArea',
      },
      Price: {
        labelRender: ({ value }) => `${numeral(value.start).format('$0,0')}–${numeral(value.end).format('0,0')}`,
        increment: 75000,
      },
      Sqft: {
        labelRender: ({ value }) => `${numeral(value.start).format('0,0')}–${numeral(value.end).format('0,0')} SQ FT`,
        increment: 750,
      },
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js